module.exports = window["wcStripeModules"]["checkoutModules"];